import { FormattedMessage as FM } from "react-intl";

import { STYLE_SHEET_CARD } from "../constants";

function SheetCard({ title, children }) {
  return (
    <section className={STYLE_SHEET_CARD}>
      <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-neutral-500">
        <FM id={title} />
      </h3>
      {children}
    </section>
  );
}

export default SheetCard;
